/** Data module calls that the shared api helper doesn't cover: multipart uploads and file links. */
import type { Msg } from "../../../contract";
import { ApiError } from "../../../web/lib/api";
import { getLanguage, t } from "../../../web/lib/i18n";
import type { ImportDTO } from "../shared/types";

export const BASE = "/m/data";

/** POST multipart to /api/m/data/... and return JSON, with errors translated like api.ts. */
export async function postForm<T>(path: string, form: FormData): Promise<T> {
  let res: Response;
  try {
    res = await fetch(`/api${BASE}${path}`, { method: "POST", body: form, credentials: "same-origin", headers: { "accept-language": getLanguage() } });
  } catch {
    throw new ApiError(0, "offline", t("You're offline. Try again when you have signal."));
  }
  const text = await res.text();
  const data = text ? JSON.parse(text) : null;
  if (!res.ok) throw new ApiError(res.status, data?.error ?? "error", t(data?.message ?? "Something went wrong on our side. Try again."), data?.issues ?? []);
  return data as T;
}

export function uploadImport(files: File[], extra: { source_id?: string; source_name?: string; exported_on?: string } = {}): Promise<ImportDTO> {
  const form = new FormData();
  for (const f of files) form.append("files", f, f.name);
  for (const [k, v] of Object.entries(extra)) if (v) form.append(k, v);
  // A spreadsheet's own date is the best guess at when it was exported; people can change it.
  if (!extra.exported_on && files.length) {
    const earliest = Math.min(...files.map((f) => f.lastModified || Date.now()));
    form.append("exported_on", new Date(earliest).toISOString().slice(0, 10));
  }
  return postForm<ImportDTO>("/imports", form);
}

/** A same-origin link to a file route; the session cookie authorizes it. */
export const fileUrl = (path: string) => `/api${BASE}${path}`;

export const tm = (m: Msg | null | undefined) => (m ? t(m.text, m.values) : "");
